// Environment configuration
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

export const config = {
  // API URLs - Everything uses auritas browser API
  apiBaseUrl: process.env.REACT_APP_ADMIN_API_BASE_URL || 'https://auritas-browser-api-fqa7gyahfjfchhb9.westus2-01.azurewebsites.net',
  adminApiBaseUrl: process.env.REACT_APP_ADMIN_API_BASE_URL || 'https://auritas-browser-api-fqa7gyahfjfchhb9.westus2-01.azurewebsites.net',
  
  // Google API
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  
  // Environment flags
  isDevelopment,
  isProduction,
  
  // Debug logging
  enableDebugLogs: isDevelopment,
}; 